<script>
export default {
  name: 'promotional',
  data() {
    return {
      username: localStorage.getItem('name'),
      stock: [],
      // 表格数据
      loading: true,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      choice: [],
      total: 0,
      dialogFormVisible: false,
      promotional: {
        id: "",
        description: "",
        code: "",
        name: "",
        endtime: "",
        discount: 0
      },
      optionProps: {
        expandTrigger: 'hover',
        title: "name",
        label: "name",
        value: "id",
        children: "children",
        checkStrictly: true
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
        shortcuts: [{
          text: '明天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '半个月',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 15);
            picker.$emit('pick', date);
          }
        }, {
          text: '一个月',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', date);
          }
        }, {
          text: '三个月',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit('pick', date);
          }
        }, {
          text: '半年',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 182);
            picker.$emit('pick', date);
          }
        }, {
          text: '一年',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
            picker.$emit('pick', date);
          }
        }
        ]
      },
    }
  },
  mounted() {
    this.getList()
    this.getStock()
  },
  methods: {
    getStock() {
      this.$axios.get("/admin/stock/classSortAndClass").then((res) => {
        this.stock = res.data.data
      })
    },
    // 获取数据
    getList() {
      this.loading = true
      this.$axios.get("/admin/promotional", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((res) => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.loading = false
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    // 打开对话框
    handleClick(e) {
      this.dialogFormVisible = true
      this.promotional.id = e.id
      this.promotional.code = e.code
      this.promotional.name = e.name
      this.promotional.endtime = e.endtime
      this.promotional.discount = e.discount
      this.promotional.description = e.description
    },
    clearForm() {
      this.promotional.id = ""
      this.promotional.code = ""
      this.promotional.name = ""
      this.promotional.endtime = ""
      this.promotional.discount = ""
      this.promotional.description = ""
    },
    setPromotional() {
      if (this.promotional.id == "") {
        this.$confirm('请选择商品', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      if (this.promotional.endtime == "") {
        this.$confirm('请选择促销结束时间', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      if (this.promotional.discount == 0 || this.promotional.discount > 1) {
        this.$confirm('请输入折扣或检查折扣是否正确（折扣不能大于1）', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      if (typeof this.promotional.id != "string") {
        let id = "";
        this.promotional.id.forEach((item) => {
          id += item + '_'
        })
        this.promotional.id = id.substring(0, id.length - 1)
      }
      this.$axios.post("/admin/promotional", this.promotional).then((res) => {
        this.$axios.post("/admin/log", {
          "type": "管理员",
          "module": "促销管理",
          "name": this.username,
          "content": "添加了'" + this.promotional.id + "'的促销"
        })
        this.dialogFormVisible = false
        this.getList()
        this.close()
        this.$message.success("修改成功")
      }).catch((r) => {
        this.$message.error("修改失败")
      })
    },
    close() {
      this.dialogFormVisible = false
      this.clearForm()
    },
    addPromotional() {
      this.dialogFormVisible = true
    },
    selectProductType(data) {
    },
    deleteP(e) {
      this.$confirm('此操作将永久删除' + e.name + '的促销活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete("/admin/promotional/" + e.id).then((res) => {
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "促销管理",
            "name": this.username,
            "content": "删除了'" + e.name + "'的促销"
          })
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getList()
        }).catch((r) => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    batchDelete() {
      let name = ''
      this.choice.forEach(e => {
        name += e.name + '，'
      })
      this.$confirm('此操作将永久删除' + name + '的促销, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = ''
        this.choice.forEach(e => {
          id += e.id + '_'
        })
        id = id.substring(0, id.length - 1)
        this.$axios.delete("/admin/promotional/batch/" + id).then((res) => {
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "促销管理",
            "name": this.username,
            "content": "删除了'" + name + "'的促销"
          })
          this.getList()
          this.$message.success("删除成功")
        }).catch((error) => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleSelectionChange(v) {
      this.choice = v
    },
    out() {
      this.$router.push({name: 'login'})
    }
  }

}
</script>
<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>促销管理</el-breadcrumb-item>
        <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
          <div style="display:flex;align-items:center;">
            <el-avatar size="large" style="margin: 5px;"
                       src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            {{ username }}
            <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
          </div>
        </div>
      </el-breadcrumb>
      <el-button class="topInput" type="primary" @click="addPromotional">添加促销商品</el-button>
      <el-button class="topInput" type="danger" @click="batchDelete">批量删除</el-button>
    </el-header>
    <el-main class="el-main">
      <el-table
          v-loading="loading"
          :data="tableData"
          stripe
          border
          highlight-current-row
          @selection-change="handleSelectionChange"
          current-row-key="id"
          max-height="500">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{ (scope.$index + 1) + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="商品编号" align="center" width="120"></el-table-column>
        <el-table-column prop="name" label="商品名称" align="center" width="200"></el-table-column>
        <el-table-column prop="endtime" align="center" label="促销结束时间"
                         width="110"></el-table-column>
        <el-table-column show-overflow-tooltip prop="discount" align="center" label="折扣"
                         width="100"></el-table-column>
        <el-table-column show-overflow-tooltip prop="description" align="center" label="折扣描述"
                         width="300"></el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="medium">编辑</el-button>
            <el-button @click="deleteP(scope.row)" type="text" size="medium">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="el-footer" id="page">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :pager-count="11"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-footer>
    <el-dialog title="编辑促销商品" :visible.sync="dialogFormVisible">
      <el-form :model="promotional" :inline="true">
        <el-form-item label="商品">
          <el-cascader
              filterable
              v-model="promotional.id"
              :options="stock"
              :props=optionProps
              placeholder="请选择" @change="selectProductType"
              clearable></el-cascader>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
              v-model="promotional.endtime"
              align="right"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
              :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="折扣">
          <el-tooltip class="item" effect="dark" content="请输入小数（如：9折输入0.9）" placement="top-start">
            <el-input v-model="promotional.discount" autocomplete="off"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="折扣描述">
          <el-input type="textarea" style="width: 500px;"
                    autosize
                    v-model="promotional.description" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="setPromotional()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
.el-header {
  margin-top: 30px;
  margin-left: 25px;
}

.topInput {
  margin-top: 15px;
  margin-bottom: 30px;
}

.el-form .el-form-item {
  margin: 10px;
}

.el-main {
  margin-top: 10px;
  margin-left: 25px;
}

.el-footer {
  text-align: center;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/promotionalView.vue